module.exports = __webpack_public_path__ + "img/adhka-yx1zn.005.af197e01.jpeg";